/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-08T19:23:44.672
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialClaimCancellationApply,
	listFinancialClaimCancellationApplyInit,
	listFinancialClaimCancellationApplyByAuthorizations,
	deleteFinancialClaimCancellationApply
	
} from '@api/financial/FinancialClaimCancellationApply';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialClaimCancellationApply({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialClaimCancellationApply(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialClaimCancellationApplyByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialClaimCancellationApplyByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialClaimCancellationApplyInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialClaimCancellationApplyInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialClaimCancellationApply({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialClaimCancellationApply({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
